import { ButtonSize, ButtonVariant } from "@galaxy-io/dls/buttons/Button";
import Text, { TextSize, TextVariant } from "@galaxy-io/dls/text/Text";
import { t } from "@galaxy-io/dls/theme/tokens/t";
import { styled } from "@linaria/react";
import { CaretLeftIcon, CaretRightIcon } from "@phosphor-icons/react";
import type { ReactNode } from "react";
import { Button } from "@/components/ui/button";
export type TablePaging = {
  page: number;
  total?: number;
  hasPrevious: boolean;
  hasNext: boolean;
  busy?: boolean;
  onPrevious: () => void;
  onNext: () => void;
};
const Footer = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  flex-wrap: wrap;
  flex-shrink: 0;
  min-height: 48px;
  gap: ${t.space[8]};
  padding: ${t.space[8]} ${t.space[12]};
  border-top: 0.5px solid ${t.color.border.primary};
  background: ${t.color.background.base};
`;
const Actions = styled.div`
  display: flex;
  align-items: flex-end;
  gap: ${t.space[8]};
  min-width: 0;
  max-width: 100%;
  overflow-x: auto;
  > * {
    flex-shrink: 0;
  }
`;
export function TableFooter({
  label,
  selected,
  total,
  totalTruncated = false,
  actions,
  paging,
}: {
  label: string;
  selected?: number;
  total?: number;
  totalTruncated?: boolean;
  actions?: ReactNode;
  paging?: TablePaging;
}) {
  return (
    <Footer role="region" aria-label={`${label} controls`}>
      <Actions>
        {total !== undefined && (
          <Text size={TextSize.BODY_SM} variant={TextVariant.SECONDARY}>
            {total.toLocaleString()}
            {totalTruncated ? "+" : ""} total
          </Text>
        )}
        {selected !== undefined && (
          <Text size={TextSize.BODY_SM} variant={TextVariant.SECONDARY}>
            {selected} selected
          </Text>
        )}
        {actions}
      </Actions>
      {paging && (
        <Actions>
          <Button
            size={ButtonSize.SMALL}
            label="Previous"
            icon={CaretLeftIcon}
            variant={ButtonVariant.SECONDARY}
            isDisabled={!paging.hasPrevious || paging.busy}
            onClick={paging.onPrevious}
          />
          <Text size={TextSize.BODY_SM} variant={TextVariant.SECONDARY}>
            Page {paging.page}
          </Text>
          <Button
            size={ButtonSize.SMALL}
            label="Next"
            icon={CaretRightIcon}
            isIconTrailing
            variant={ButtonVariant.SECONDARY}
            isDisabled={!paging.hasNext || paging.busy}
            onClick={paging.onNext}
          />
        </Actions>
      )}
    </Footer>
  );
}
